import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.267 6.587l-3.06-3.06c-.125-.124-.294-.194-.47-.194s-.345.07-.47.194c-.062.062-.112.136-.146.217s-.051.168-.051.256.017.175.051.256.083.155.146.217l3.067 3.053c.062.062.112.136.146.217s.051.168.051.256-.017.175-.051.256-.083.155-.146.217l-3.067 3.053c-.126.125-.196.294-.197.471s.069.347.194.472.294.196.471.197.347-.069.472-.194l3.06-3.06a2 2 0 0 0 0-2.827z",
		fill: "currentColor"
	})
});
export default SvgRightArrow;
